/* src/app/master-data/brands/brands-list/brands-list.component.css */
/*# sourceMappingURL=brands-list.component-XIOYUS7D.css.map */
